export default __webpack_public_path__ + "static/media/img-faq@2x.c7621b83.png";